<template>
  <div
    class="front-video-cloud-wrap"
    :class="{ 'is-cloud-magnified': cloudImgFlag }"
  >
    <!-- 施工中 / 已停工提示：位于前场面板之外上方 -->
    <div
      v-if="pavingStatus == 1"
      class="pave-working-banner"
    >
      <span class="pave-working-status">施工中</span>
    </div>
    <div
      v-if="pavingStatus == 2"
      class="pave-halt-banner"
    >
      <span class="pave-halt-status">已停工</span>
      <span class="pave-halt-label">最后摊铺时间:</span>
      <span class="pave-halt-time">{{ lastPaveTimeText || '-/-' }}</span>
    </div>

    <div class="front-video-cloud">
    <!-- 上方：当日累计摊铺 + 实时信息 -->
    <div class="front-info-panel">
      <frontInfo :type="materialType" />
    </div>

    <!-- 中部：云图（iframe 直接加载） -->
    <div class="cloud-panel">
      <div class="cloud-wrap" ref="cloudWrap">
        <iframe
          v-if="cloudUrl"
          ref="cloudIframe"
          id="bdIframeFrontCloud"
          :src="cloudUrl"
          frameborder="0"
          scrolling="no"
        ></iframe>
        <div v-else class="offline-tip">云图加载中...</div>
        <i
          class="el-icon-full-screen cloud-fullscreen-btn"
          title="放大查看"
          @click="bigThanBig"
        ></i>
      </div>
    </div>

    <!-- 下方：前场视频（对齐 PC CameraItem 直播：默认暂停不取流，悬浮控件） -->
    <div class="video-panel">
      <div
        class="video-wrap"
        ref="videoWrap"
      >
        <!-- EZUIKit 容器：与 PC CameraItem 一致，ezopen 取流 -->
        <div v-if="videoUrl" :id="videoContainerId" class="ez-video-container"></div>

        <div v-if="deviceChecked && !paverCamera" class="offline-tip">设备不在线</div>

        <!-- 暂停冻结画面（放在播放器容器外，避免被 EZUIKit 清掉） -->
        <img
          v-if="pauseImageUrl && (!playFlag || playLoading)"
          :src="pauseImageUrl"
          class="pause-image"
          alt="暂停画面"
        >

        <!-- 暂停 → 播放过渡加载 -->
        <div v-if="playLoading" class="play-loading">
          <i class="el-icon-loading play-loading-icon"></i>
          <span class="play-loading-text">加载中</span>
        </div>

        <!-- 中央播放：仅暂停/空闲态；播放中由萤石云工具栏控制 -->
        <div
          v-if="videoUrl && !playLoading && !playFlag"
          class="center-control paused"
          @click="play"
        >
          <i class="el-icon-video-play center-control-icon"></i>
        </div>
      </div>
    </div>
    </div>

    <!-- 云图放大弹层 -->
    <div class="cloudImgMBox" v-show="cloudImgFlag">
      <div class="cloudImgM" ref="cloudImgM">
        <div @click="closeCloud" class="closeCloud"><i class="el-icon-close"></i></div>
        <iframe
          ref="IframeM"
          id="bdIframeFrontCloudM"
          :src="bdTokenUrl2"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getVideoConfigGetList,
  captureImage,
  getLastPaveTimeByWorkArea
} from '@/api/api'
import { mapState } from 'vuex'
import EZUIKit from 'ezuikit-js'
import { buildPcLiveThemeData } from '@/utils/ezuikitTheme'
import frontInfo from './frontInfo'

// 自动暂停时长（分钟）
const AUTO_PAUSE_MINUTES = 10

/**
 * 前场视频：取流/播放器对齐 PC CameraItem 直播
 * 1. getVideoConfigGetList 取设备（含 accessToken、isPtz）
 * 2. 构造 ezopen 直播地址
 * 3. EZUIKit themeData（pcLive 同款）+ staticPath + decodeEngine:0
 * 4. 默认暂停不取流；点击播放才创建播放器
 */
export default {
  name: 'FrontVideoCloud',
  components: {
    frontInfo
  },
  data () {
    return {
      materialType: 'lq',
      paverCamera: null,
      videoUrl: '',
      quality: 2,
      cloudUrl: '',
      cloudImgFlag: false,
      bdTokenUrl2: '',
      deviceChecked: false,
      playFlag: false,
      playLoading: false,
      ezPlayerInstance: null,
      videoContainerId: 'front-cloud-ez-video',
      pauseImageUrl: '',
      autoPauseTimer: null,
      playStartTime: null,
      loadSeq: 0,
      reloadTimer: null,
      pavingStatus: null,
      lastPaveTime: ''
    }
  },
  computed: {
    ...mapState([
      'engineerId',
      'sectionId',
      'workAreaId',
      'seIds'
    ]),
    maxPlayMinutes () {
      return AUTO_PAUSE_MINUTES
    },
    lastPaveTimeText () {
      return this.formatPaveTime(this.lastPaveTime)
    },
    supportsPtz () {
      const val = this.paverCamera && this.paverCamera.isPtz
      return val === 1 || val === '1' || val === true
    }
  },
  mounted () {
    this.materialType = this.$route.path.indexOf('lq') >= 0 ? 'lq' : 'sw'
    this.scheduleReload()
    this.fetchPavingStatus()
    window.addEventListener('resize', this.onWinResize)
  },
  beforeDestroy () {
    this._isDestroyed = true
    window.removeEventListener('resize', this.onWinResize)
    if (this.reloadTimer) clearTimeout(this.reloadTimer)
    this.clearPlayLoadingTimer()
    this.clearAutoPauseTimer()
    this.unbindResizeObserver()
    if (this._resizeTimer) {
      clearTimeout(this._resizeTimer)
      this._resizeTimer = null
    }
    if (this._playResizeTimers && this._playResizeTimers.length) {
      this._playResizeTimers.forEach(t => clearTimeout(t))
      this._playResizeTimers = null
    }
    this.destroyEZPlayer()
  },
  methods: {
    onWinResize () {
      this.resizeCloudIframe()
      this.scheduleResizePlayer()
    },

    scheduleReload () {
      this.fetchPavingStatus()
      if (!this.engineerId || !this.sectionId || !this.workAreaId) return
      if (this.reloadTimer) clearTimeout(this.reloadTimer)
      this.reloadTimer = setTimeout(() => {
        this.reloadTimer = null
        this.reloadAll()
      }, 400)
    },

    formatPaveTime (val) {
      if (!val && val !== 0) return ''
      const str = String(val).trim()
      if (!str) return ''
      if (str.indexOf(' ') >= 0) {
        return str.split(' ')[1] || str
      }
      return str
    },

    async fetchPavingStatus () {
      if (!this.sectionId) {
        this.pavingStatus = null
        this.lastPaveTime = ''
        return
      }
      try {
        const paveRes = await getLastPaveTimeByWorkArea({
          workAreaId: this.sectionId
        })
        const paveBody = paveRes && paveRes.data
        const pavePayload = (paveBody && paveBody.resultData != null)
          ? paveBody.resultData
          : paveBody
        this.pavingStatus = null
        this.lastPaveTime = ''
        if (typeof pavePayload === 'string' || typeof pavePayload === 'number') {
          this.lastPaveTime = pavePayload
        } else if (pavePayload && typeof pavePayload === 'object') {
          this.lastPaveTime = pavePayload.paveTime || ''
          this.pavingStatus = pavePayload.pavingStatus
        }
      } catch (e) {
        this.pavingStatus = null
        this.lastPaveTime = ''
      }
    },

    async reloadAll () {
      if (!this.engineerId || !this.sectionId || !this.workAreaId) return
      this.loadCloudMap()
      await this.loadPaverCamera()
    },

    generateTimestampId () {
      const timestamp = Date.now().toString()
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let rand = ''
      if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        const arr = new Uint32Array(16)
        crypto.getRandomValues(arr)
        for (const n of arr) rand += chars[n % chars.length]
      } else {
        for (let i = 0; i < 16; i++) rand += chars[Math.floor(Math.random() * chars.length)]
      }
      return timestamp + rand
    },

    getTodayDate () {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },

    loadCloudMap () {
      const time = this.getTodayDate()
      this.cloudUrl =
        `https://cloudvue-henan.jsti-smart.cn/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.seIds}&isHistory=realTime&materialType=${this.materialType}&time=${time}&machineType=13&authkey=${this.generateTimestampId()}&hiddenDiv=hidden`
      this.$nextTick(() => {
        this.resizeCloudIframe()
      })
    },

    bigThanBig () {
      const that = this
      this.cloudImgFlag = true
      that.$nextTick(function () {
        const oIframeM = document.getElementById('bdIframeFrontCloudM')
        const deviceWidthM = that.$refs.cloudImgM ? that.$refs.cloudImgM.offsetWidth : 0
        const deviceHeightM = that.$refs.cloudImgM ? that.$refs.cloudImgM.offsetHeight : 0
        if (oIframeM && deviceWidthM > 0) {
          oIframeM.style.width = Number(deviceWidthM) - 2 + 'px'
          oIframeM.style.height = Number(deviceHeightM) - 2 + 'px'
        }
        const time = that.getTodayDate()
        that.bdTokenUrl2 =
          `https://cloudvue-henan.jsti-smart.cn/?workArea=${that.sectionId}&engineerId=${that.engineerId}&sectionId=${that.seIds}&isHistory=realTime&materialType=${that.materialType}&time=${time}&machineType=13&authkey=${that.generateTimestampId()}`
      })
    },

    closeCloud () {
      this.cloudImgFlag = false
      this.bdTokenUrl2 = ''
    },

    resizeCloudIframe () {
      const iframe = document.getElementById('bdIframeFrontCloud')
      const wrap = this.$refs.cloudWrap
      if (!iframe || !wrap) return
      const w = wrap.offsetWidth
      const h = wrap.offsetHeight
      if (w > 0 && h > 0) {
        iframe.style.width = w - 2 + 'px'
        iframe.style.height = h - 2 + 'px'
      }
    },

    parseDeviceList (data) {
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.result)) return data.result
      if (data && Array.isArray(data.records)) return data.records
      if (data && Array.isArray(data.data)) return data.data
      return []
    },

    async loadPaverCamera () {
      const seq = ++this.loadSeq
      this.clearAutoPauseTimer()
      await this.destroyEZPlayer()
      if (seq !== this.loadSeq) return

      this.videoUrl = ''
      this.playFlag = false
      this.pauseImageUrl = ''
      this.playLoading = false
      this.quality = 2

      try {
        const paverReq = {
          engineeringId: this.engineerId,
          sectionId: this.workAreaId,
          workareaId: this.sectionId,
          codeType: 2
        }
        const { data: paverData } = await getVideoConfigGetList(paverReq)
        if (seq !== this.loadSeq) return

        const paverDeviceList = this.parseDeviceList(paverData)
        const paverDevice = paverDeviceList.find(device => device.site === 10)
        this.deviceChecked = true
        if (!paverDevice) {
          this.paverCamera = null
          return
        }

        this.paverCamera = {
          site: 10,
          name: '摊铺机',
          channelNo: paverDevice.channel || '1',
          serialNumber: paverDevice.serialNumber,
          accessToken: paverDevice.accessToken,
          isPtz: this.normalizeIsPtz(paverDevice.isPtz)
        }

        if (!this.paverCamera.accessToken || !this.paverCamera.serialNumber) {
          this.$message.warning('视频播放失败：缺少授权信息')
          this.paverCamera = null
          return
        }

        // 与 PC 一致：进页即持有 ezopen 地址，默认不创建播放器（不取流）
        this.videoUrl = this.buildLiveUrl(
          this.paverCamera.serialNumber,
          this.paverCamera.channelNo,
          this.quality
        )
        await this.prepareIdleState()
        this.$nextTick(() => {
          this.bindResizeObserver()
        })
      } catch (e) {
        console.error('加载前场视频失败', e)
        if (seq === this.loadSeq) {
          this.deviceChecked = true
          this.paverCamera = null
        }
      }
    },

    normalizeIsPtz (val) {
      if (val === 1 || val === '1' || val === true) return 1
      return 0
    },

    // 官方：标清 .live / 高清 .hd.live；业务 quality：1=高清，2=标清
    buildLiveUrl (serialNumber, channelNo, quality) {
      const qualityPart = Number(quality) === 1 ? '.hd' : ''
      return `ezopen://open.ys7.com/${serialNumber}/${channelNo}${qualityPart}.live`
    },

    async prepareIdleState () {
      this.playFlag = false
      this.clearAutoPauseTimer()
      await this.destroyEZPlayer({ keepPauseImage: true })
      await this.$nextTick()
      if (this._isDestroyed || this.playFlag) return
      await this.freezeCurrentFrame()
    },

    clearPlayLoadingTimer () {
      if (this._playLoadingTimer) {
        clearTimeout(this._playLoadingTimer)
        this._playLoadingTimer = null
      }
    },

    finishPlayLoading () {
      this.clearPlayLoadingTimer()
      this.playLoading = false
    },

    // 仅在首帧真正出来后再清封面，避免 play 事件先到导致黑屏
    clearPauseCover () {
      this.pauseImageUrl = ''
    },

    waitForContainerSize (retry = 0) {
      return new Promise((resolve) => {
        const wrap = this.$refs.videoWrap
        const container = document.getElementById(this.videoContainerId)
        const w = Math.floor((wrap && (wrap.clientWidth || wrap.offsetWidth)) || (container && (container.clientWidth || container.offsetWidth)) || 0)
        const h = Math.floor((wrap && (wrap.clientHeight || wrap.offsetHeight)) || (container && (container.clientHeight || container.offsetHeight)) || 0)
        if ((w > 2 && h > 2) || retry >= 20) {
          resolve({ width: w, height: h })
          return
        }
        setTimeout(() => {
          this.waitForContainerSize(retry + 1).then(resolve)
        }, 50)
      })
    },

    async startLivePlay () {
      if (!this.paverCamera || !this.videoUrl) return
      this.playLoading = true
      this.clearPlayLoadingTimer()
      this._playLoadingTimer = setTimeout(() => {
        this.finishPlayLoading()
      }, 15000)

      try {
        // 保留 pauseImageUrl 直到首帧，覆盖黑屏间隙
        await this.$nextTick()
        const size = await this.waitForContainerSize()
        if (!size || size.width < 2 || size.height < 2) {
          this.finishPlayLoading()
          this.$message.warning('视频容器尺寸异常，请稍后重试')
          return
        }
        await this.initEZPlayer({ autoStart: true })
      } catch (e) {
        this.finishPlayLoading()
      }
    },

    async play () {
      if (this._playSwitching || !this.paverCamera) return
      this._playSwitching = true
      try {
        if (this.playFlag) {
          // 暂停：抓拍封面后销毁播放器，彻底停流省流量（与 PC 一致）
          this.finishPlayLoading()
          this._skipStopCapture = true
          await this.freezeCurrentFrame()
          await this.destroyEZPlayer({ keepPauseImage: true })
          this.playFlag = false
          this.clearAutoPauseTimer()
          this.$nextTick(() => {
            this._skipStopCapture = false
          })
        } else {
          await this.startLivePlay()
        }
      } finally {
        this._playSwitching = false
      }
    },

    async capturePauseImage () {
      if (!this.paverCamera || !this.paverCamera.accessToken) return ''
      try {
        const res = await captureImage({
          accessToken: this.paverCamera.accessToken,
          deviceSerial: this.paverCamera.serialNumber,
          channelNo: this.paverCamera.channelNo || '1'
        })
        if (this._isDestroyed) return ''
        const picUrl = res && res.data && res.data.data ? res.data.data.picUrl : ''
        this.pauseImageUrl = picUrl || ''
        return picUrl || ''
      } catch (error) {
        console.error('截图失败:', error)
        this.pauseImageUrl = ''
        return ''
      }
    },

    async freezeCurrentFrame () {
      const picUrl = await this.capturePauseImage()
      return !!picUrl
    },

    async initEZPlayer (options = {}) {
      const autoStart = options.autoStart === true
      await this.$nextTick()

      if (this.ezPlayerInstance) {
        await this.destroyEZPlayer({ keepPauseImage: true })
      }

      const container = document.getElementById(this.videoContainerId)
      if (!container || !this.videoUrl || !this.paverCamera) return
      if (!this.paverCamera.serialNumber || !this.paverCamera.accessToken) return

      try {
        // 等容器有尺寸后再按 16:9 计算播放器宽高
        await this.waitForContainerSize()
        let size = this.getPlayerViewportSize()
        let width = (size && size.width) || 0
        let height = (size && size.height) || 0
        if (width < 2) width = 484
        if (height < 2) height = Math.floor(width * 9 / 16)
        this._lastPlayerSize = { w: width, h: height }

        // 先用像素钉死 16:9 容器并居中，再交给 SDK
        container.style.width = `${width}px`
        container.style.height = `${height}px`
        container.style.left = '50%'
        container.style.top = '50%'
        container.style.transform = 'translate(-50%, -50%)'

        this.ezPlayerInstance = new EZUIKit.EZUIKitPlayer({
          id: this.videoContainerId,
          accessToken: this.paverCamera.accessToken,
          url: this.videoUrl,
          themeData: buildPcLiveThemeData(this.supportsPtz, false),
          width,
          height,
          autoplay: !!autoStart,
          lowerZindex: true,
          decodeEngine: 0,
          staticPath: '/static/ezuikit_static'
        })

        this.playFlag = false

        const onFirstFrame = () => {
          this.playFlag = true
          this.finishPlayLoading()
          this.clearPauseCover()
          this.startAutoPauseTimer()
          this.forceResizePlayerAfterPlay()
        }

        this.ezPlayerInstance.on('firstFrameDisplay', onFirstFrame)
        this.ezPlayerInstance.on('play', () => {
          this.playFlag = true
          this.startAutoPauseTimer()
          // 部分环境无 firstFrameDisplay：延后结束 loading，但仍保留封面片刻
          if (this.playLoading) {
            setTimeout(() => {
              if (this._isDestroyed) return
              this.finishPlayLoading()
              // 再等一帧周期后清封面，降低黑闪
              setTimeout(() => {
                if (!this._isDestroyed && this.playFlag) this.clearPauseCover()
              }, 300)
            }, 600)
          }
          this.forceResizePlayerAfterPlay()
        })
        this.ezPlayerInstance.on('stop', () => {
          this.finishPlayLoading()
          if (this._skipStopCapture) {
            this.playFlag = false
            this.clearAutoPauseTimer()
            return
          }
          if (!this.pauseImageUrl) {
            this.capturePauseImage()
          }
          this.playFlag = false
          this.clearAutoPauseTimer()
        })
        this.ezPlayerInstance.on('error', (error) => {
          console.error('EZUIKit 播放器错误:', error)
          this.finishPlayLoading()
        })

        this.$nextTick(() => {
          this.bindResizeObserver()
          this.forceResizePlayerAfterPlay()
        })
      } catch (error) {
        this.finishPlayLoading()
        console.error('EZUIKit 播放器初始化失败:', error)
        this.$message.error('视频播放器初始化失败')
      }
    },

    async destroyEZPlayer (options = {}) {
      const keepPauseImage = options.keepPauseImage === true
      this.clearAutoPauseTimer()

      const player = this.ezPlayerInstance
      this.ezPlayerInstance = null
      if (!player) {
        this.playFlag = false
        if (!keepPauseImage) this.pauseImageUrl = ''
        const empty = document.getElementById(this.videoContainerId)
        if (empty) empty.innerHTML = ''
        return
      }

      try {
        if (typeof player.stop === 'function') {
          await Promise.race([
            Promise.resolve(player.stop()).catch(() => {}),
            new Promise(resolve => setTimeout(resolve, 500))
          ])
        }
      } catch (e) { /* ignore */ }

      try {
        if (typeof player.destroy === 'function') {
          player.destroy()
        } else if (typeof player.close === 'function') {
          player.close()
        }
      } catch (error) {
        console.warn('销毁播放器时出错:', error)
      }

      const container = document.getElementById(this.videoContainerId)
      if (container) container.innerHTML = ''
      this.playFlag = false
      if (!keepPauseImage) this.pauseImageUrl = ''
    },

    startAutoPauseTimer () {
      this.clearAutoPauseTimer()
      this.playStartTime = Date.now()
      const minutes = this.maxPlayMinutes
      const timeout = minutes * 60 * 1000
      this.autoPauseTimer = setTimeout(async () => {
        if (this._isDestroyed || !this.playFlag) return
        try {
          this._skipStopCapture = true
          await this.freezeCurrentFrame()
          await this.destroyEZPlayer({ keepPauseImage: true })
          this.playFlag = false
          this.$nextTick(() => {
            this._skipStopCapture = false
          })
          this.$message.info(`视频已播放${minutes}分钟,已自动暂停`)
        } catch (error) {
          this._skipStopCapture = false
          console.error('自动暂停失败:', error)
        }
      }, timeout)
    },

    clearAutoPauseTimer () {
      if (this.autoPauseTimer) {
        clearTimeout(this.autoPauseTimer)
        this.autoPauseTimer = null
        this.playStartTime = null
      }
    },

    // ========== 尺寸适配 ==========
    bindResizeObserver () {
      if (typeof ResizeObserver === 'undefined') return
      const el = this.$refs.videoWrap
      if (!el) return
      this.unbindResizeObserver()
      this._resizeObserver = new ResizeObserver(() => {
        this.scheduleResizePlayer()
      })
      this._resizeObserver.observe(el)
    },

    unbindResizeObserver () {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect()
        this._resizeObserver = null
      }
    },

    scheduleResizePlayer () {
      if (this._resizeTimer) clearTimeout(this._resizeTimer)
      this._resizeTimer = setTimeout(() => {
        this._resizeTimer = null
        this.resizePlayer()
      }, 50)
    },

    getPlayerViewportSize () {
      const wrap = this.$refs.videoWrap
      const container = document.getElementById(this.videoContainerId)
      const el = wrap || container
      if (!el) return null

      let boxW = Math.floor(el.clientWidth || el.offsetWidth || 0)
      let boxH = Math.floor(el.clientHeight || el.offsetHeight || 0)

      if (boxW < 2 || boxH < 2) return null

      // 宽度优先撑满，高度按 16:9 适配；容器不够高时再按高度约束宽度，避免拉伸变形
      let width = boxW
      let height = Math.floor(width * 9 / 16)
      if (height > boxH) {
        height = boxH
        width = Math.floor(height * 16 / 9)
      }
      return { width, height, boxW, boxH }
    },

    resizePlayer (force = false) {
      if (!this.ezPlayerInstance || this._isDestroyed) return
      const size = this.getPlayerViewportSize()
      if (!size) return
      const { width, height } = size
      if (!force && this._lastPlayerSize && this._lastPlayerSize.w === width && this._lastPlayerSize.h === height) {
        return
      }
      this._lastPlayerSize = { w: width, h: height }
      try {
        if (typeof this.ezPlayerInstance.reSize === 'function') {
          this.ezPlayerInstance.reSize(width, height)
        } else if (typeof this.ezPlayerInstance.resize === 'function') {
          this.ezPlayerInstance.resize(width, height)
        }
      } catch (e) { /* ignore */ }

      const container = document.getElementById(this.videoContainerId)
      if (container) {
        // 用 setProperty 提高优先级，避免全屏样式把尺寸冲掉导致黑屏
        container.style.setProperty('width', `${width}px`, 'important')
        container.style.setProperty('height', `${height}px`, 'important')
        container.style.setProperty('left', '50%', 'important')
        container.style.setProperty('top', '50%', 'important')
        container.style.setProperty('transform', 'translate(-50%, -50%)', 'important')
        container.style.setProperty('max-width', 'none', 'important')
        container.style.setProperty('max-height', 'none', 'important')
      }
    },

    forceResizePlayerAfterPlay () {
      if (this._playResizeTimers && this._playResizeTimers.length) {
        this._playResizeTimers.forEach(t => clearTimeout(t))
      }
      this._playResizeTimers = []
      const run = () => {
        if (this._isDestroyed) return
        this._lastPlayerSize = null
        this.resizePlayer(true)
      }
      this.$nextTick(run)
      ;[60, 150, 300, 500].forEach(ms => {
        this._playResizeTimers.push(setTimeout(run, ms))
      })
    }
  },
  watch: {
    engineerId () {
      this.scheduleReload()
    },
    sectionId () {
      this.scheduleReload()
    },
    workAreaId () {
      this.scheduleReload()
    },
    seIds () {
      if (this.sectionId) this.loadCloudMap()
    },
    $route (to) {
      this.materialType = to.path.indexOf('lq') >= 0 ? 'lq' : 'sw'
      this.loadCloudMap()
    }
  }
}
</script>

<style lang="less" scoped>
.front-video-cloud-wrap {
  position: fixed;
  right: 25px;
  top: 120px;
  bottom: 30px;
  width: 500px;
  z-index: 998;
  pointer-events: none;
  box-sizing: border-box;

  &.is-cloud-magnified {
    z-index: 1002;
  }
}

.pave-halt-banner,
.pave-working-banner {
  position: absolute;
  left: -20px;
  top: -38px;
  z-index: 1000;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  box-sizing: border-box;
  white-space: nowrap;
  pointer-events: none;
}

.pave-halt-banner {
  min-width: 274px;
  padding: 0 14px 0 60px;
  background: url(../assets/img/ytg.png) no-repeat left center / 100% 100%;
}

.pave-working-banner {
  min-width: 128px;
  padding: 0 12px 0 60px;
  background: url(../assets/img/sgz.png) no-repeat left center / 100% 100%;
}

.pave-halt-status {
  font-size: 14px;
  font-weight: 500;
  color: #ff4d4f;
  line-height: 1;
}

.pave-working-status {
  font-size: 14px;
  font-weight: 500;
  color: #3CFF5A;
  line-height: 1;
}

.pave-halt-label {
  font-size: 14px;
  color: #ffffff;
  line-height: 1;
}

.pave-halt-time {
  font-size: 14px;
  font-weight: 500;
  color: #fff721;
  line-height: 1;
}

.front-video-cloud {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 998;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  box-sizing: border-box;
  padding: 8px;
  padding-top: 0;
  background: url(../assets/img/qcbj.png) no-repeat center / 100% 100%;
}

.front-info-panel {
  flex: 0 0 auto;
  height: 260px;
  position: relative;
  overflow: hidden;
}

.cloud-fullscreen-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  padding: 4px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 2px;
  opacity: 0.9;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
}

.cloudImgMBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1002;
  /* 父级 wrap 为 pointer-events: none，弹层需显式恢复可点击 */
  pointer-events: auto;
}

.cloudImgM {
  width: 97vw;
  height: 92vh;
  position: absolute;
  z-index: 1002;
  left: 1vw;
  top: 5vh;
  background-color: #fff;
  border: 2px solid #000;

  iframe {
    display: block;
    border: 0;
  }
}

.closeCloud {
  position: absolute;
  right: -25px;
  top: -30px;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: #fff;
  border: 1px solid #000;
  text-align: center;
  line-height: 50px;
  font-weight: 900;
  font-size: 25px;
  cursor: pointer;
  z-index: 10;
  pointer-events: auto;
}

.video-panel,
.cloud-panel {
  display: flex;
  flex-direction: column;
  background: transparent;
  border: none;
  box-sizing: border-box;
  overflow: hidden;
}

.video-panel {
  flex: 1;
  min-height: 0;
  position: relative;
  width: 100%;
}

.cloud-panel {
  flex: 1;
  min-height: 0;
}

.cloud-wrap {
  flex: 1;
  position: relative;
  min-height: 0;
  background: #000;
}

.cloud-wrap iframe {
  display: block;
  border: 0;
  width: 100%;
  height: 100%;
}

.offline-tip {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  background: #000;
  z-index: 5;
}

.video-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
}

.ez-video-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: auto;
  max-height: 100%;

  /deep/ video,
  /deep/ canvas,
  /deep/ iframe {
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    object-fit: contain !important;
  }
}

.pause-image {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 95;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #000;
  pointer-events: none;
}

.play-loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 110;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  pointer-events: none;

  .play-loading-icon {
    font-size: 36px;
    color: #fff;
  }

  .play-loading-text {
    margin-top: 10px;
    font-size: 13px;
    letter-spacing: 1px;
    opacity: 0.9;
  }
}

.center-control {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 104;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.28);
  transition: opacity 0.2s ease;

  &.paused {
    opacity: 1;
    pointer-events: auto;
  }

  .center-control-icon {
    font-size: 72px;
    color: #fff;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45));
    transition: transform 0.2s ease;
  }

  &:hover .center-control-icon {
    transform: scale(1.08);
  }
}

/deep/.ezui-player-wrapper {
  width: 100% !important;
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/subassembly/frontVideoCloud.vue